import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import PortalSidebar from "./PortalSidebar";
import Header from "./Header"; // Your existing top navbar
import useEnforceTestParam from "../utils/useEnforceTestParam";

const PortalLayout = ({ children }) => {
  useEnforceTestParam();

  return (
    <Flex direction="column" minHeight="100vh">
      {/* Persistent Top Navbar */}
      <Header />

      <Flex flex="1" overflow="hidden">
        {/* Sidebar */}
        <PortalSidebar />

        {/* Main Content */}
        <Box
          flex="1"
          bg="gray.50"
          p={{ base: 4, md: 8 }}
          overflowY="auto"
          minHeight="100vh"
        >
          {children}
        </Box>
      </Flex>
    </Flex>
  );
};

export default PortalLayout;
